import { IFormFieldType } from '@/widgets/create-widget'
import { MediaType } from '@/constants/constants'

const LearningPedagogySectionSchema: { [key: string]: IFormFieldType } = {
  learningPedagogySection: {
    type: 'Object',
    label: 'Learning Pedagogy Section',
    required: false,
    children: {
      heading: {
        type: 'String',
        label: 'Heading',
        required: false,
      },
      subHeading: {
        type: 'String',
        label: 'Sub Heading',
        required: false,
      },
      cards: {
        type: 'List',
        label: 'Cards',
        required: false,
        children: {
          title: {
            type: 'String',
            label: 'Title',
            required: false,
          },
          description: {
            type: 'String',
            label: 'Description',
            required: false,
          },
          image: {
            type: 'Media',
            mediaTypes: [MediaType.IMAGE],
            label: 'Image',
            required: false,
          },
        },
      },
    },
  },
}

export default LearningPedagogySectionSchema

export type LearningPedagogySectionProps = {
  heading: string
  subHeading: string
  cards: {
    title: string
    description: string
    image: string
  }[]
}

export type learningPedagogy = {
  learningPedagogySection: LearningPedagogySectionProps
}

export const LearningPedagogySectionDefaultValues: learningPedagogy = {
  learningPedagogySection: {
    heading: "CuriousJr's Way of Teaching",
    subHeading: 'On a Mission to Revolutionise Traditional Education Pratices',
    cards: [
      {
        title: 'Hands-on projects',
        description: 'Focus on experiments, and real-life applications',
        image:
          'https://static.pw.live/production-curiousjr-fundoo/static/images/learning-pedagogy/digital-education.svg',
      },
      {
        title: 'Interactive Sessions',
        description: 'Play-based learning for deeper understanding of the concepts',
        image:
          'https://static.pw.live/production-curiousjr-fundoo/static/images/learning-pedagogy/girl-taking-online-class.svg',
      },
      {
        title: 'Future Ready',
        description: 'Developing communication, empathy, and leadership skills',
        image:
          'https://static.pw.live/production-curiousjr-fundoo/static/images/learning-pedagogy/male-book-cover.svg',
      },
    ],
  },
}
